import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22typography.utils.ts%22,%22import%22:%22%22,%22arguments%22:[{%22variable%22:%22--font-myriad-pro%22,%22adjustFontFallback%22:false,%22declarations%22:[{%22prop%22:%22ascent-override%22,%22value%22:%22100%%22}],%22src%22:[{%22path%22:%22./fonts/MyriadPro/MyriadProRegular/font.woff2%22,%22weight%22:%22100%20500%22,%22style%22:%22normal%22},{%22path%22:%22./fonts/MyriadPro/MyriadProSemibold/font.woff2%22,%22weight%22:%22600%20900%22,%22style%22:%22normal%22}]}],%22variableName%22:%22myriadPro%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'myriadPro'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
